import React from "react";
import {CategoryColor}  from "../utils/CategoryColor";
import PostContent  from './content';
import PostHeaderMeta from "./post-header-meta"
import DesktopPostHeader from "./desktop-post-header"
import PostMobile from './post_mobile.js'
import HashtagList from './hashtag-list'
import {ContentUtils}  from "../utils/ContentUtils";


function Article(
  { postId,
    id,
    vertical,
    kind,
    content,
    featuredImage,
    uri,
    link,
    date,
    author,
    categories,
    tags,
    excerpt,
    title_clean,
    template_file,
    categoria_landing_img,
    categoria_landing_text,
    vertical_feature_image_position,
    from404,
    primary_category,
    primary_category_override,
    primary_category_override_link,
    video_embedded_home,
    video_content,
    base_id

  }) {
  let time_read = ContentUtils.showTime(content);
  return(
      <div
        className="newmag-single-article"
        primary_category={primary_category}
        vertical={vertical}
        id="START"
      >
        {/*questo tag ha il css degli articoli*/}
        <article
          data-id={id}
          id={`post-article-${vertical}-${postId}`}
          className={`newmag-article post-${postId} post type-post status-publish format-standard hentry category-react tag-accessibility tag-gatsby entry`}
        >
          <DesktopPostHeader
            style={{ display: "none" }}
            primary_category_override_link={primary_category_override_link}
            primary_category_override={primary_category_override}
            array_colors={CategoryColor.array_colors}
            title={title_clean}
            uri={uri}
            featuredImage={featuredImage}
            categories={categories}
            author={author}
            video_embedded_home={video_embedded_home}
            video_content={video_content}
          ></DesktopPostHeader>
          <PostMobile
            primary_category_override_link={primary_category_override_link}
            primary_category_override={primary_category}
            title_clean={title_clean}
            uri={uri}
            featuredImage={featuredImage}
            author={author}
            video_embedded_home={video_embedded_home}
            video_content={video_content}
          ></PostMobile>
          <div id="clonable" data-url={uri}>
            <div className="post-header-meta">
              <PostHeaderMeta
                postId={postId}
                kind={"POST"}
                vertical={vertical}
                uri={uri}
                link={link}
                title={title_clean}
                date={date}
                author={author}
                excerpt={excerpt}
                featuredImage={
                  featuredImage && featuredImage.node ?
                  featuredImage.node : ((typeof featuredImage==='string') ? featuredImage : '')
                }
                content={content}
                template={template_file}
                categoria_landing_img={categoria_landing_img}
                categoria_landing_text={categoria_landing_text}
                categoria_landing_link={primary_category_override_link}
                primary_category={primary_category}
                categories={categories}
                primary_category_link={primary_category_override_link}
                time_read={time_read}
                vertical_feature_image_position={vertical_feature_image_position}
                base_id={`#post-article-${vertical}-${postId}`}
                from404={from404}
              />
            </div>
            <PostContent
              postId={postId}
              vertical={vertical}
              kind={kind}
              content={content}
              featuredImage={featuredImage}
            ></PostContent>
            <footer className="entry-footer" style={{marginBottom: '3rem'}}>
              <HashtagList tags={tags}>
              </HashtagList>
            </footer>
          </div>
        </article>
      </div>
  );
}

export default Article;
